import { render } from "./OrbitModules.vue?vue&type=template&id=2bd1cecb&scoped=true"
import script from "./OrbitModules.vue?vue&type=script&lang=js"
export * from "./OrbitModules.vue?vue&type=script&lang=js"

import "./OrbitModules.vue?vue&type=style&index=0&id=2bd1cecb&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd1cecb"]])

export default __exports__